export default __webpack_public_path__ + "static/media/toy14.0bee5d48.jfif";